document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const minusButtons = document.querySelectorAll('.quantity__button[name="minus"]');
    minusButtons.forEach(function(button) {
      button.removeEventListener('click', handleMinusClick);
      button.addEventListener('click', handleMinusClick, true); 
    });
  }, 500);
  function handleMinusClick(e) {
    const button = e.target.closest('.quantity__button[name="minus"]');
    const quantityInput = button.parentNode.querySelector('.quantity__input');
    const currentQuantity = parseInt(quantityInput.value);
    console.log('Clic sur moins, quantité actuelle:', currentQuantity);
    if (currentQuantity === 1) {
      e.preventDefault();
      e.stopImmediatePropagation(); 
      const cartItem = button.closest('.cart-item');
      const removeButton = cartItem.querySelector('cart-remove-button a');
      
      if (removeButton) {
        removeButton.click();
      }
      
      return false;
    }
  }
});